import React, { Component } from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import Bold from 'material-ui/svg-icons/editor/format-bold';
import Italic from 'material-ui/svg-icons/editor/format-italic';
import Underline from 'material-ui/svg-icons/editor/format-underlined';
import UL from 'material-ui/svg-icons/editor/format-list-bulleted';
import OL from 'material-ui/svg-icons/editor/format-list-numbered';
import Left from 'material-ui/svg-icons/editor/format-align-left';
import Right from 'material-ui/svg-icons/editor/format-align-right';
import Centered from 'material-ui/svg-icons/editor/format-align-center';
import Justify from 'material-ui/svg-icons/editor/format-align-justify';
import Quote from 'material-ui/svg-icons/editor/format-quote';
import IconButton from 'material-ui/IconButton';

const BLOCK_TYPES = [
  { label: 'Nečíslovaný seznam', style: 'unordered-list-item', Icon: UL },
  { label: 'Číslovaný seznam', style: 'ordered-list-item', Icon: OL },
  { label: 'Citace', style: 'blockquote', Icon: Quote },
];

const ALIGN_BUTTONS = [
  { label: 'Zarovnat vlevo', align: 'left', Icon: Left },
  { label: 'Zarovnat vpravo', align: 'right', Icon: Right },
  { label: 'Zarovnat na střed', align: 'center', Icon: Centered },
  { label: 'Zarovnat do bloku', align: 'justify', Icon: Justify },
];

const INLINE_STYLES = [
  { label: 'Tučně', style: 'BOLD', Icon: Bold },
  { label: 'Italika', style: 'ITALIC', Icon: Italic },
  { label: 'Podtrhnout', style: 'UNDERLINE', Icon: Underline },
];

const FONT_STYLES = [
  { label: 'Normální', style: 'unstyled' },
  { label: 'Nadpis 1', style: 'header-one' },
  { label: 'Nadpis 2', style: 'header-two' },
  { label: 'Nadpis 3', style: 'header-three' },
  { label: 'Nadpis 4', style: 'header-four' },
  { label: 'Nadpis 5', style: 'header-five' },
  { label: 'Nadpis 6', style: 'header-six' },
];

class StyleButton extends Component {
  onToggle = e => {
    e.preventDefault();
    this.props.onToggle(this.props.style);
  }

  render() {
    const { children, label } = this.props;
    return (
      <IconButton tooltip={label} onMouseDown={this.onToggle}>
        {children}
      </IconButton>
    );
  }
}

export class BlockStyleControls extends Component {
  state = {
    value: ''
  };

  handleChange = (event, index, value) => {
    this.props.onToggle(value);
    this.setState({ value });
  }

  render() {
    const { editorState, onToggle, onAlign } = this.props;
    const selection = editorState.getSelection();
    const block = editorState.getCurrentContent().getBlockForKey(selection.getStartKey());
    const blockType = block.getType();
    const currentAlign = block.getData() && block.getData().get('textAlign');
    const fontStyle = FONT_STYLES.find(fs => fs.style === blockType)?.style;

    return (
      <div className="controls">
          <SelectField
            value={fontStyle || 'unstyled'}
            onChange={this.handleChange}
            style={{ width: 180 }}
          >
            {FONT_STYLES.map(type =>
              <MenuItem key={type.label} value={type.style} primaryText={type.label} />
            )}
        </SelectField>
        {BLOCK_TYPES.map((Type) =>
          <StyleButton
            key={Type.label}
            label={Type.label}
            onToggle={onToggle}
            style={Type.style}
          >
            <Type.Icon color={Type.style === blockType ? '#1f5f9d' : 'black'} />
          </StyleButton>
        )}
        {ALIGN_BUTTONS.map((btn) =>
          <IconButton
            key={btn.label}
            tooltip={btn.label}
            onMouseDown={(e) => { e.preventDefault(); onAlign(btn.align); }}
          >
            <btn.Icon color={btn.align === currentAlign ? '#1f5f9d' : 'black'} />
          </IconButton>
        )}
      </div>
    );
  };
};

export const InlineStyleControls = ({ editorState, onToggle }) => {
  const currentStyle = editorState.getCurrentInlineStyle();
  return (
    <div className="controls">
      {INLINE_STYLES.map(Type =>
        <StyleButton
          key={Type.label}
          active={currentStyle.has(Type.style)}
          label={Type.label}
          onToggle={onToggle}
          style={Type.style}
        >
          <Type.Icon color={currentStyle.has(Type.style) ? '#1f5f9d' : 'black'} />
        </StyleButton>
      )}
    </div>
  );
};
